import { useEffect, useState } from "react";
import { Bar, BarChart, CartesianGrid, Legend, ResponsiveContainer, Tooltip, XAxis, YAxis } from "recharts";
import { adminApi } from "@/lib/api";

const SHORT = ["Gen", "Feb", "Mar", "Apr", "Mag", "Giu", "Lug", "Ago", "Set", "Ott", "Nov", "Dic"];
const money = (v, c) => `${c} ${Number(v || 0).toLocaleString("de-CH", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;

const Tip = ({ active, payload, label }) => {
  if (!active || !payload?.length) return null;
  const p = payload[0].payload;
  return (
    <div className="bg-white border border-[#d5dbde] px-3 py-2 text-xs font-mono space-y-1">
      <div className="text-[#2B3036] font-medium">{label} · {p.count} fatture</div>
      <div className="text-[#E0262C]">{money(p.eur, "EUR")}</div>
      <div className="text-[#5b6168]">{money(p.chf, "CHF")}</div>
    </div>
  );
};

export const RevenueChart = ({ year }) => {
  const [rows, setRows] = useState([]);
  useEffect(() => {
    adminApi.invoicesMonthly(year || undefined)
      .then((d) => setRows(d.months.map((m) => ({ ...m, label: `${SHORT[m.month - 1]} ${String(m.year).slice(2)}` }))))
      .catch(() => {});
  }, [year]);
  const sum = (c) => rows.reduce((a, r) => a + r[c], 0);
  return (
    <div data-testid="inv-revenue-chart" className="border border-[#d5dbde] p-5">
      <div className="flex flex-wrap items-baseline justify-between gap-3 mb-4">
        <div className="text-[10px] uppercase tracking-widest font-mono text-[#6b7280]">Incassi mese per mese · {year || "ultimi 12 mesi"}</div>
        <div className="text-xs font-mono text-[#5b6168] space-x-4">
          <span data-testid="inv-chart-total-eur">{money(sum("eur"), "EUR")}</span>
          <span data-testid="inv-chart-total-chf">{money(sum("chf"), "CHF")}</span>
        </div>
      </div>
      <div className="h-64">
        <ResponsiveContainer width="100%" height="100%">
          <BarChart data={rows} barGap={2}>
            <CartesianGrid stroke="#d5dbde" vertical={false} />
            <XAxis dataKey="label" tick={{ fill: "#5b6168", fontSize: 11 }} axisLine={{ stroke: "#d5dbde" }} tickLine={false} />
            <YAxis tick={{ fill: "#5b6168", fontSize: 11 }} axisLine={false} tickLine={false} width={50} />
            <Tooltip content={<Tip />} cursor={{ fill: "#eef1f2" }} />
            <Legend wrapperStyle={{ fontSize: 11, fontFamily: "monospace", color: "#3f454c" }} formatter={(v) => <span style={{ color: "#3f454c" }}>{v}</span>} />
            <Bar dataKey="eur" name="EUR" fill="#E0262C" radius={[2, 2, 0, 0]} />
            <Bar dataKey="chf" name="CHF" fill="#6b7280" radius={[2, 2, 0, 0]} />
          </BarChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
};
